<div class="modal-header" style="background: #37669e; color: #fff;">
  <h5 class="modal-title">
    <i class="fa fa-exclamation-triangle"></i> Session Timeout Warning
  </h5>
  <button type="button" class="close" (click)="dismiss()" aria-label="Close" style="color: #fff;">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-center">
  <div class="alert alert-warning">
    <i class="fa fa-clock-o fa-3x mb-3"></i>
    <h4>Your session is about to expire</h4>
    <p class="mb-2">You have been inactive for a while. Your session will expire soon.</p>
    <div class="countdown-timer">
      <h2 class="text-danger">
        <strong>{{ formatTime(remainingMinutes) }}:{{ formatTime(remainingSeconds) }}</strong>
      </h2>
      <p class="text-muted">Time remaining before automatic logout</p>
    </div>
  </div>
  <p class="mt-3">
    Click "Continue Session" to stay logged in, or you will be automatically logged out.
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="extendSession()">
    <i class="fa fa-refresh"></i> Continue Session
  </button>
  <button type="button" class="btn btn-secondary" (click)="dismiss()">
    Close
  </button>
</div>

